var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpened(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C14.6897 0 17.974 2.18957 20.8302 6.44248L21.2046 7L20.8302 7.55752C17.974 11.8104 14.6897 14 11 14C7.31032 14 4.02596 11.8104 1.16982 7.55752L0.79541 7L1.16982 6.44248C4.02596 2.18957 7.31032 0 11 0ZM11 2C8.21187 2 5.62382 3.6307 3.21623 7C5.62382 10.3693 8.21187 12 11 12C13.7881 12 16.3762 10.3693 18.7837 7C16.3762 3.6307 13.7881 2 11 2ZM11 4C12.6568 4 14 5.34315 14 7C14 8.65685 12.6568 10 11 10C9.34313 10 7.99999 8.65685 7.99999 7C7.99999 5.34315 9.34313 4 11 4Z",
    fill: "#6F758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpened);
export default __webpack_public_path__ + "static/media/eye-opened.ad768f1f69c728ff557dc56ebb89bdf5.svg";
export { ForwardRef as ReactComponent };